module.exports = __webpack_public_path__ + "img/terms-and-conditions.671f9794.svg";